// extracted by mini-css-extract-plugin
export default {"text-input":"textInput_text-input__usO8X","input-error":"textInput_input-error__-a8Xz"};